/**
 * @param {*} value
 * @returns {string|undefined}
 */
function businessId (value) {
  if (!value) return

  let val = value
    .toString()
    .toUpperCase()
    .replace(/[^A-Z0-9-+]/g, '')

  if (val.length >= 8 && val.charAt(7) !== '-') {
    val = val.substring(0, 7) + '-' + val.substring(7, 8)
  }

  return val
}

module.exports = { businessId }
